module.exports = __webpack_public_path__ + "img/admin-permisos.b4138234.svg";